var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "svg",
      {
        class: { active: _vm.hover },
        staticStyle: { "enable-background": "new 0 0 496 496" },
        attrs: {
          xmlns: "http://www.w3.org/2000/svg",
          "xmlns:xlink": "http://www.w3.org/1999/xlink",
          version: "1.1",
          id: "Capa_1",
          x: "0px",
          y: "0px",
          viewBox: "0 0 496 496",
          "xml:space": "preserve",
          width: "44.8px",
          height: "44.8px"
        },
        on: {
          mouseover: function($event) {
            _vm.hover = true
          },
          mouseleave: function($event) {
            _vm.hover = false
          }
        }
      },
      [
        _c(
          "g",
          {
            attrs: {
              transform: "matrix(-0.950895 0 0 -0.950895 483.822 479.067)"
            }
          },
          [
            _c("g", [
              _c(
                "g",
                {
                  class: { active: _vm.hover },
                  on: {
                    mouseover: function($event) {
                      _vm.hover = true
                    },
                    mouseleave: function($event) {
                      _vm.hover = false
                    }
                  }
                },
                [
                  _c(
                    "g",
                    {
                      class: { active: _vm.hover },
                      on: {
                        mouseover: function($event) {
                          _vm.hover = true
                        },
                        mouseleave: function($event) {
                          _vm.hover = false
                        }
                      }
                    },
                    [
                      _c("path", {
                        staticClass: "active-path",
                        class: { active: _vm.hover },
                        attrs: {
                          d:
                            "M248,0C111.033,0,0,111.033,0,248s111.033,248,248,248s248-111.033,248-248C495.841,111.099,384.901,0.159,248,0z      M248,480C119.87,480,16,376.13,16,248S119.87,16,248,16s232,103.87,232,232C479.859,376.072,376.072,479.859,248,480z",
                          "data-original": "#d74551",
                          fill: "#d74551"
                        },
                        on: {
                          mouseover: function($event) {
                            _vm.hover = true
                          },
                          mouseleave: function($event) {
                            _vm.hover = false
                          }
                        }
                      }),
                      _vm._v(" "),
                      _c("path", {
                        staticClass: "active-path",
                        class: { active: _vm.hover },
                        attrs: {
                          d:
                            "M361.136,134.864c-3.124-3.123-8.188-3.123-11.312,0L248,236.688L146.176,134.864c-3.069-3.178-8.134-3.266-11.312-0.197     c-3.178,3.069-3.266,8.134-0.197,11.312c0.064,0.067,0.13,0.132,0.197,0.197L236.688,248L134.864,349.824     c-3.178,3.07-3.266,8.134-0.196,11.312c3.07,3.178,8.134,3.266,11.312,0.196c0.067-0.064,0.132-0.13,0.196-0.196L248,259.312     l101.824,101.824c3.178,3.07,8.242,2.982,11.312-0.196c2.995-3.1,2.995-8.016,0-11.116L259.312,248l101.824-101.824     C364.259,143.052,364.259,137.988,361.136,134.864z",
                          "data-original": "#d74551",
                          fill: "#d74551"
                        },
                        on: {
                          mouseover: function($event) {
                            _vm.hover = true
                          },
                          mouseleave: function($event) {
                            _vm.hover = false
                          }
                        }
                      })
                    ]
                  )
                ]
              )
            ])
          ]
        )
      ]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-335bf789", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-335bf789","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./src/components/component/close/close.html
// module id = null
// module chunks = 